export default __webpack_public_path__ + "static/media/535.0b4a9e04.jpg";